import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAnimatePath: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAnimatePath"><Path d="M2.75 19.25C2.75 19.25 3.875 7.75 7.25 7.75C10.625 7.75 11.75 19.25 11.75 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M11.75 19.2501C11.75 19.2501 12.142 13.3895 15.9947 9.03125" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Circle cx="18.5" cy="7.5" r="2.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconAnimatePath;
